// src/skillsData.js

const skillsData = [
  {
    category: "Software Development & IT",
    skills: [
      "Backend Development",
      "Frontend Development ",
      "Full Stack Development",
      "Mobile App Development (iOS/Swift)",
      "Mobile App Development (Android/Kotlin/Java)",
      "Game Development",
      "DevOps Engineering",
      "Cloud Architecture (AWS, Azure, GCP)",
      "Cybersecurity",
      "Database Administration (e.g., SQL, NoSQL)",
      "Network Engineering",
      "System Administration",
      "Quality Assurance (QA) & Testing",
      "Blockchain Development",
      "Embedded Systems Programming",
      "Robotics Programming",
      "IT Support & Helpdesk",
      "ERP/CRM Implementation (e.g., SAP, Salesforce)",
      "Low-Code/No-Code Development",
    ]
  },
  {
    category: "Data Science, AI & Analytics",
    skills: [
      "Machine Learning Engineering",
      "Deep Learning Specialist",
      "Data Science & Predictive Modeling",
      "Big Data Technologies (e.g., Hadoop, Spark)",
      "Natural Language Processing (NLP)",
      "Computer Vision",
      "Data Analysis & Visualization (e.g., Tableau, Power BI)",
      "Business Intelligence (BI)",
      "Statistical Analysis",
      "Data Engineering",
      "Econometrics",
      "A/B Testing & Experimentation",
    ]
  },
  {
    category: "Design & Creative Arts",
    skills: [
      "UI/UX Design",
      "Graphic Design",
      "Web Design",
      "Product Design",
      "Interaction Design",
      "Motion Graphics Design",
      "Illustration",
      "Photography",
      "Videography & Video Editing",
      "Animation (2D/3D)",
      "Sound Design & Audio Production",
      "Copywriting",
      "Content Creation (e.g., Blogging, Vlogging)",
      "Creative Direction",
      "Fashion Design",
      "Interior Design",
      "Industrial Design",
      "Architecture",
    ]
  },
  {
    category: "Marketing & Sales",
    skills: [
      "Digital Marketing Strategy",
      "Search Engine Optimization (SEO)",
      "Search Engine Marketing (SEM/PPC)",
      "Social Media Marketing",
      "Content Marketing",
      "Email Marketing",
      "Affiliate Marketing",
      "Brand Management",
      "Public Relations (PR)",
      "Sales Strategy & Development",
      "Account Management",
      "Customer Relationship Management (CRM)",
      "Market Research",
      "E-commerce Management",
      "Partnership Development",
    ]
  },
  {
    category: "Business & Management",
    skills: [
      "Project Management",
      "Product Management",
      "Business Analysis",
      "Operations Management",
      "Strategic Planning",
      "Financial Analysis & Modeling",
      "Accounting & Bookkeeping",
      "Human Resources Management",
      "Recruitment & Talent Acquisition",
      "Supply Chain Management",
      "Logistics",
      "Consulting",
      "Entrepreneurship & Startup Growth",
      "Risk Management",
      "Compliance & Regulations",
      "Quality Management",
      "Change Management",
    ]
  },
  {
    category: "Healthcare & Medical",
    skills: [
      "Nursing (e.g., RN, LPN)",
      "Medicine (e.g., General Practice, Specialist fields)",
      "Pharmacy",
      "Physical Therapy",
      "Occupational Therapy",
      "Speech-Language Pathology",
      "Medical Research",
      "Public Health",
      "Healthcare Administration",
      "Medical Billing & Coding",
      "Clinical Trials Management",
      "Biostatistics",
      "Epidemiology",
      "Nutritional Counseling",
    ]
  },
  {
    category: "Education & Training",
    skills: [
      "Teaching (K-12, Higher Ed, Adult Education)",
      "Curriculum Development",
      "Instructional Design",
      "Corporate Training",
      "Academic Tutoring",
      "Educational Administration",
      "Special Education",
      "Career Counseling",
      "Mentorship Development",
    ]
  },
  {
    category: "Trades & Manual Skills",
    skills: [
      "Electrician",
      "Plumbing",
      "Carpentry",
      "HVAC Technician",
      "Automotive Repair & Maintenance",
      "Welding",
      "Culinary Arts & Cooking",
      "Baking & Pastry Arts",
      "Gardening & Landscaping",
      "Construction Management",
      "Heavy Equipment Operation",
      "Mechanics",
      "Sewing & Tailoring",
      "Hair Styling & Cosmetology",
    ]
  },
  {
    category: "Communication & Media",
    skills: [
      "Journalism & Reporting",
      "Editing & Proofreading",
      "Technical Writing",
      "Creative Writing",
      "Public Speaking",
      "Debate & Argumentation",
      "Broadcasting (Radio, TV)",
      "Podcasting",
      "Film Production",
      "Event Planning",
      "Intercultural Communication",
      "Translation & Localization",
      "Crisis Communication",
    ]
  },
  {
    category: "Science & Research",
    skills: [
      "Biology & Biotechnology",
      "Chemistry",
      "Physics",
      "Environmental Science",
      "Geology & Earth Sciences",
      "Astronomy",
      "Archaeology",
      "Sociology",
      "Psychology",
      "Research Methodology",
      "Laboratory Techniques",
      "Statistical Modeling (Scientific)",
    ]
  },
  {
    category: "Legal & Public Service",
    skills: [
      "Legal Research",
      "Contract Law",
      "Criminal Law",
      "Civil Litigation",
      "Paralegal Support",
      "Public Administration",
      "Policy Analysis",
      "Law Enforcement",
      "Emergency Services",
      "Social Work",
      "Community Outreach",
      "Non-profit Management",
    ]
  },
  {
    category: "Soft Skills & Personal Development",
    skills: [
      "Leadership",
      "Teamwork & Collaboration",
      "Problem-Solving",
      "Critical Thinking",
      "Adaptability & Flexibility",
      "Effective Communication",
      "Time Management & Organization",
      "Emotional Intelligence",
      "Negotiation",
      "Conflict Resolution",
      "Active Listening",
      "Coaching & Mentoring",
      "Creativity & Innovation",
      "Resilience",
      "Decision Making",
      "Interpersonal Skills",
      "Self-Management",
    ]
  }
];

export default skillsData;
